import SEOHead from "@/components/SEOHead";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import WhyChooseUs from "@/components/WhyChooseUs";
import Mission from "@/components/Mission";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";
import Support from "@/components/Support";
import TryUsOut from "@/components/TryUsOut";
import NoCloseGuarantee from "@/components/NoCloseGuarantee";

const Index = () => (
  <div id="home" className="min-h-screen bg-background">
    <SEOHead
      title="ATC – Automated Transaction Coordinator | Real Estate TC Services"
      description="Full-service real estate transaction coordination. Save 15-20 hours per deal. No Close Guarantee included."
      canonical="/"
    />
    <Navbar />
    <main>
      <Hero />
      <TryUsOut />
      <About />
      <NoCloseGuarantee />
      <Services />
      <WhyChooseUs />
      <Mission />
      <FAQ />
      <Support />
    </main>
    <Footer />
  </div>
);

export default Index;
